import * as React from 'react';
import { observer } from 'mobx-react';

const styles = require('./EmptySpacer.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class EmptySpacer extends React.Component<{}, {}> {
    render() {
        return <div className={classNames(styles.emptySpacer)} />;
    }
}
